import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  maillons: [],
  maillon: null
}

// mutations
export const mutations = {
  [types.SET_MAILLONS] (state, maillons) {
    state.maillons = maillons
  },
  [types.SET_MAILLON] (state, maillon) {
    state.maillon = maillon
  },
  [types.FETCH_MAILLON_FAILURE] (state) {
    state.maillon = null
  }
}

// actions
export const actions = {
  async fetchMaillons ({ commit }) {
    try {
      const { data } = await axios.get('/api/maillons?include=actor_type,')
      commit(types.SET_MAILLONS, data)
    } catch (e) {
      console.log(e)
    }
  },
  async fetchMaillon ({ commit }, maillon) {
    try {
      const { data } = await axios.get(`/api/maillons/${maillon.id}`)

      commit(types.SET_MAILLON, { maillon: data })
    } catch (e) {
      commit(types.FETCH_MAILLON_FAILURE)
    }
  },

  async createMaillon (context, maillon) {
    try {
      await axios.post('/api/maillons', maillon)
      context.dispatch('fetchMaillons')
    } catch (e) {
      console.log(e)
    }
  },

  async updateMaillon (context, maillon) {
    try {
      await axios.put(`/api/maillons/${maillon.id}`, maillon)
      context.dispatch('fetchMaillons')
    } catch (e) { }
  },

  async deleteMaillon (context, maillon) {
    try {
      await axios.delete(`/api/maillons/${maillon.id}`)
      context.dispatch('fetchMaillons')
    } catch (e) { }
  }
}

// getters
export const getters = {
  maillons: state => state.maillons
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/maillon.js